<div class="crossIcon ion-hide" (click)="action()">
  <ion-icon name="close-outline"></ion-icon>
</div>
<ion-header mode="md">
  <ion-toolbar>
    <ion-title>{{'DispatchTo'|language:'Dispatch To'}}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="action()" shape="round">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="content">
    <div class="header ion-hide">
      <p>{{'DispatchTo'|language:'Dispatch To'}}</p>
    </div>
    <div class="fixed">
      <ion-segment class="ind-btn" [(ngModel)]="segment" scrollable>
        <ion-segment-button color="light" class="dm-btn" mode="md" value="0">
          <p><ion-icon size="small" name="storefront-outline"></ion-icon>{{'ownDelivery'|language:'Own Delivery'}}</p>
        </ion-segment-button>
        <ion-segment-button class="dm-btn" mode="md" value="1" [disabled]="orderItem?.raPosFlag">
          <p><ion-icon size="small" src="assets/icon/delivery-boy.svg"></ion-icon>{{'thirdParty'|language:'Third
            Party'}}
          </p>
        </ion-segment-button>
      </ion-segment>
      <div [ngSwitch]="segment">
        <div *ngSwitchCase="'0'">
          <ion-searchbar [debounce]="500" show-clear-button="focus" mode="ios" id="myInput"
            [(ngModel)]="searchAssociated" (ionChange)="searchDeliveryBoyAssociated()" #search
            placeholder="{{'search' | language : 'Search'}}">
          </ion-searchbar>
        </div>
        <div *ngSwitchCase="'1'">
          <ion-searchbar [debounce]="500" show-clear-button="focus" mode="ios" id="myInput"
            [(ngModel)]="searchFreelance" (ionChange)="searchDeliveryBoyfreelance()" #searchF
            placeholder="{{'search' | language : 'Search'}}">
          </ion-searchbar>
        </div>
      </div>
    </div>
    <span [ngSwitch]="segment">
      <span *ngSwitchCase="'0'">
        <div>
          <ion-row>
            <ion-col size="6" size-sm="4" size-md="3" size-lg="3" class="cd" *ngFor="let data of self; let i = index"
              (click)="selectAssociated(data?._id)">
              <div class="img">
                <ion-img src="{{data?.profileImage ? data?.profileImage : '/assets/images/profilePic1.svg'}}" class=""
                  alt=""></ion-img>
              </div>
              <p>{{data?.name}}</p>
              <p>{{data?.phone}}</p>
            </ion-col>
            <ion-col size="6" size-sm="4" size-md="3" size-lg="3" class="cd"
              *ngFor="let data of searchAssociated ? filteredAssociated : associated; let i = index"
              (click)="selectAssociated(data?._id)">
              <div class="img">
                <ion-img src="{{data?.profileImage ? data?.profileImage : '/assets/images/profilePic1.svg'}}" class=""
                  alt=""></ion-img>
              </div>
              <p>{{data?.name}}</p>
              <p>{{data?.phone}}</p>
            </ion-col>
          </ion-row>
        </div>
      </span>
      <ion-slides *ngSwitchCase="'1'">
        <ion-button class="autoAssignButton" shape="round" expand="block" (click)="deliveryboyAutoAssign()">
          {{'autoAssign' | language : 'Auto Assign'}}
        </ion-button>
        <div>
          <ion-row>
            <ion-col size="6" size-sm="4" size-md="3" size-lg="3" class="cd"
              *ngFor="let data of searchFreelance ? filteredFreelanced : freelancer; let i = index"
              (click)="selectFreelancer(data?._id)">
              <div class="img">
                <ion-img src="{{data?.profileImage ? data?.profileImage : '/assets/images/profilePic1.svg'}}" class=""
                  alt=""></ion-img>
              </div>
              <p>{{data?.name}}</p>
              <p>{{data?.phone}}</p>
            </ion-col>
          </ion-row>
        </div>
      </ion-slides>
    </span>
  </div>
</ion-content>